import axios from "axios";
import { ActiveExperimentsResponse } from "redmond";
import { platformApiApi } from "@capone/platform-api";

import { config } from "../../config";

export const fetchActiveExperiments = (): Promise<ActiveExperimentsResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await platformApiApi(axios).apiV0ExperimentsActivePut({
        baseURL: config.baseURL,
      });
      resolve(res.data as unknown as ActiveExperimentsResponse);
    } catch (e) {
      reject(e);
    }
  });
